/* eslint-disable */
import React, { Component } from 'react'
import { ScrollView, Text, KeyboardAvoidingView, Dimensions } from 'react-native'
import { connect } from 'react-redux'
import { ButtonGroup, ListItem } from "react-native-elements"
import FollowComponent from '../Components/FollowComponent'
import MainNavBarScreen from './MainNavBarScreen'
import BaseScreen from './BaseScreen'
import styles from './Styles/FollowScreenStyle'
import GetFollowActions from '../Redux/GetFollowRedux'
import API from '../Services/Api'
import FixtureAPI from '../Services/FixtureApi'
import DebugConfig from '../Config/DebugConfig'
import { NavigationActions } from 'react-navigation'
import I18n from "i18n-js"

import { RecyclerListView, DataProvider, LayoutProvider } from "recyclerlistview";
class FollowScreen extends Component {
  constructor(props) {
    console.tron.log(`FollowScreen constructor begins`)
    super(props)
    this.api = DebugConfig.useFixtures ? FixtureAPI : API.create( )
    this.api.setAuthorization(this.props.token)
    let { width } = Dimensions.get('window')
    const { state: { params: { title, userId, isFollower } } } = this.props.navigation
    this.state = { 
      title,
      userId,
      isFollower,
      limit: 20,
      data: new DataProvider((r1, r2) => r1 !== r2),
      layout: new LayoutProvider( index => 0, (type, dim) => { dim.width = width; dim.height = 60 } ),
    }
    console.tron.display({ name: `FollowScreen`, preview :`constructor`, value: { props: this.props } })

    if (isFollower) {
      if (this.props.followers.userId == userId && this.props.followers.data && this.props.followers.error != true)
        this.state.data = this.state.data.cloneWithRows(this.props.followers.data)
    }
    else {
      if (this.props.following.userId == userId && this.props.following.data && this.props.following.error != true)
        this.state.data = this.state.data.cloneWithRows(this.props.following.data)
    }

    this.FollowerRow = this.FollowerRow.bind(this)
    this.toggleFollowState = this.toggleFollowState.bind(this)
    this.onAvatarPress = this.onAvatarPress.bind(this)
    this._loadMoreData = this._loadMoreData.bind(this)
    this.inLoadMoreData = false
    console.tron.log(`FollowScreen constructor ends`)
  }

  componentDidMount() {
    console.tron.display({ name: `FollowScreen`, preview :`componentDidMount begins`, value: { props: this.props, state: this.state } })
    this.navigationBar.setRightNavBarButtons([ { onPress: this.onHomePress, type: 'home' } ])
    this.navigationBar.setLeftNavBarButtons([ { onPress: this.onBackPress, type: 'back' } ])
/*
    if (this.state.isFollower) {
      if (this.props.followers.userId == this.state.userId && this.props.followers.data && this.props.followers.error != true)
        this.setState({ data: this.state.data.cloneWithRows(this.props.followers.data) })
    }
    else {
      if (this.props.following.userId == this.state.userId && this.props.following.data && this.props.following.error != true)
        this.setState({ data: this.state.data.cloneWithRows(this.props.following.data) })
    }
*/
    this.props.getFollow(this.state.userId, this.state.isFollower, {start: 0, limit: 15})
  }

  componentWillReceiveProps(nextProps) {
    console.tron.log(`FollowScreen componentWillReceiveProps begins`)
/*
    if (this.props.followers.data !== nextProps.followers.data) {
      console.tron.log(`FollowScreen componentWillReceiveProps data changed`)
      this.setState({ data: this.state.data.cloneWithRows(nextProps.followers.data) })
    }
*/    
    if (this.state.isFollower) {
      console.tron.display({ name: `FollowScreen`, preview :`componentWillReceiveProps isFollower`, value: { nextProps, props: this.props } })
      if (nextProps.followers.userId == this.state.userId && this.props.followers.timeStamp !== nextProps.followers.timeStamp) {
        console.tron.log(`FollowScreen componentWillReceiveProps followers data changed`)
        // pagination?  start != 0?  append
        this.setState({ data: this.state.data.cloneWithRows(nextProps.followers.data) })
      }
    }
    else {
      console.tron.display({ name: `FollowScreen`, preview :`componentWillReceiveProps !isFollower`, value: { nextProps, props: this.props, state: this.state } })
      if (nextProps.following.userId == this.state.userId && this.props.following.timeStamp !== nextProps.following.timeStamp) {
        console.tron.log(`FollowScreen componentWillReceiveProps following data changed`)
        // pagination?  start != 0?  append
        this.setState({ data: this.state.data.cloneWithRows(nextProps.following.data) })
      }
    }
  }
  
  _loadMoreData = async () => {
    if (this.inLoadMoreData)
      return
    this.inLoadMoreData = true
    console.tron.log(`FollowScreen _loadMoreData`)
    // TODO: improve - use pagination to figure out start, or even if there is more data...
    this.props.getFollow(this.state.userId, this.state.isFollower, {start: 0, limit: 1000})
    // ...
    this.inLoadMoreData = false
  }

  changeStateInProvider = ( UserId ) => {
    let nextData = this.state.data._data.map(fol => {
      if( fol.UserId === UserId )
        return Object.assign({ }, fol, { UserIsFollowing : fol.UserIsFollowing? false: true })
      return fol
    })
    this.setState({ data : this.state.data.cloneWithRows( nextData ) })
  }
  
  toggleFollowState = (user) => {
    let SwitchViaAPI = user.UserIsFollowing ? this.api.unfollowUser : this.api.followUser
    SwitchViaAPI( this.props.UserId, user.UserId )
    .then(resp => { if( resp.ok ) this.changeStateInProvider ( user.UserId ) })
    .catch(console.warn)
  }
  
  onAvatarPress = (userId) => {
    this.props.navigation.navigate('profile', { userId })
  }

  FollowerRow = (type, data, index) => {
    console.tron.log(`FollowScreen FollowerRow index: ${index}`)
    const { UserId, Username, UserIsFollowing } = data
    return <FollowComponent
      isSpacer
      key={index}
      onAvatarPress={() => this.onAvatarPress(UserId)}
      data={data}
      title={Username}
      userId={UserId}
      userIsFollowing={UserIsFollowing}
      onPressRightIcon={() => this.toggleFollowState(data)}
    />
  }
  
  onBackPress = ( ) => this.props.navigation.goBack()

  onHumburgerPress = ( ) => this.props.screenProps.openDrawer()

  onHomePress = ( ) => {
    this.props.navigation.dispatch(NavigationActions.reset({
        index: 0,
        key: null,
        actions: [NavigationActions.navigate({ routeName: 'home', params: { isScroll : true } })]
    }))
  }

  render() {
    console.tron.display({ name: `FollowScreen`, preview :`render begins`, value: { data: this.state.data, props: this.props } })
    let title = this.state.title
    title = (title == "Followers") ? I18n.t("followersProfile.followers") : I18n.t("followersProfile.following")
    // forceNonDeterministicRendering={true}
    return (
      <BaseScreen loading={this.props.fetching} darkStatusbar>
        <MainNavBarScreen ref={view => this.navigationBar = view} title={title} />
        <RecyclerListView containerStyle={{ marginBottom: 20, marginTop: 0 }}
          layoutProvider={this.state.layout}
          dataProvider={this.state.data}
          rowRenderer={this.FollowerRow}
          onEndReached={this._loadMoreData}
        />
      </BaseScreen>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    following: state.getFollow.following,
    followers: state.getFollow.followers,
    token: state.auth.token,
    UserId: state.auth.user.UserId,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    getFollow: (userId, isFollower, params) => dispatch(GetFollowActions.getFollowRequest(userId, isFollower, params)),
    followUser: (userId, user2Id) => dispatch(FollowActions.followRequest(userId, user2Id)),
    unFollowUser: (userId, user2Id) => dispatch(FollowActions.unfollowRequest(userId, user2Id)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FollowScreen)
